var textFieldInput = {
  sizes: {
    xSmall: {
      height: '32px'
    },
    small: {
      height: '40px'
    },
    regular: {
      height: '48px'
    },
    large: {
      height: '56px'
    }
  }
};
export default textFieldInput;